import { useStorage } from '@vueuse/core';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { computed, ref } from 'vue';

export type ScreenSize = 's' | 'm' | 'l';

export const usePageLayoutStore = defineStore('pageLayout', () => {
  const screenSize = ref<ScreenSize>('l');
  const showMobileMenu = ref(false);
  const navbarWidth = ref(0);
  const headerHeight = ref(0);
  const isMobileDesktop = useStorage('mobile_desktop_active', false);
  const isModalOpen = ref(false);
  const _isNavExpanded = useStorage('nav_expanded', false);
  const isScrollbarVisible = ref(false);

  const setScreenSize = (width?: number) => {
    const windowWidth = width || document.documentElement.clientWidth;
    screenSize.value = windowWidth < 576 ? 's' : windowWidth > 1024 ? 'l' : 'm';
  };

  const isNavExpanded = computed({
    get() {
      return _isNavExpanded.value && screenSize.value !== 's';
    },
    set(value) {
      _isNavExpanded.value = value;
    },
  });

  return {
    screenSize,
    showMobileMenu,
    navbarWidth,
    headerHeight,
    isMobileDesktop,
    isModalOpen,
    isNavExpanded,
    setScreenSize,
    isScrollbarVisible,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(usePageLayoutStore, import.meta.hot));
}
